import _post from "./Post"
import constantURI from "../URI"
const Authenticate = async () => {
    var result = false;
    const url = constantURI() + "odooController/MedRepAuthentication";
    const username = JSON.parse(localStorage.getItem("Username"));
    const password = JSON.parse(localStorage.getItem("Password"));
    const token = JSON.parse(localStorage.getItem("Token"));
    const body = {
        "params": {
            "db": "smartrep",
            "login": username,
            "password": "123"
        },
        "token": token
    }
    if (navigator.onLine) {
        setTimeout(await _post(url, body).then((response) => {
            return response.json().then((data) => {
                if (data.result === undefined) {
                    result = false;
                }
                else result = true;
            })
        }), 30000);
    }
    else {
        result = false;
    }
    return result;
}
export default Authenticate;


